import React from "react";
import ReactECharts from "echarts-for-react";
import { Card, makeStyles } from "@material-ui/core";
import styles from "./styles";

const useStyles = makeStyles(styles);

const BarChart = (props) => {
  const { title, series, categories, legends } = props;
  const classes = useStyles();


  const _series = series.map((item) => {
    return {
      name: item.name,
      data: item.data,
      itemStyle: { color: item["color"] },
      type: "bar",
      label: {
        show: true,
        formatter: item.labelFormatter,
      },
    };
  });

  const options = {
    title: {
      text: title,
    },
    legend: {
      top: "bottom",
      data: legends
    },
    tooltip: {
      trigger: "axis",
    },
    xAxis: {
      type: "category",
      data: categories,
    },
    yAxis: {
      type: "value",
    },
    series: _series,
  };

  return (
    <Card className={classes.container} variant="outlined" elevation={0}>
      <ReactECharts option={options} />
    </Card>
  );
};

export default BarChart;
